import { render, staticRenderFns } from "./PessoasGeral.vue?vue&type=template&id=807de830&scoped=true&"
import script from "./PessoasGeral.vue?vue&type=script&lang=js&"
export * from "./PessoasGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807de830",
  null
  
)

export default component.exports